import { Dispatch } from '@reduxjs/toolkit';
import { FormInstance } from 'antd/lib/form';
import { validateForm } from '@xbcb/ui-utils';
import { AdditionalFormError, ValidationErrorType } from '@xbcb/ui-types';
import { setValidationErrors } from 'actions/validation';

export const validateEntryForAoiOriginalBooking = async ({
  form,
  record,
  dispatch,
  currentUserId,
}: {
  form: FormInstance;
  record: any;
  dispatch: Dispatch;
  currentUserId?: string;
}): Promise<boolean> => {
  const additionalErrors: AdditionalFormError[] = [];
  record?.invoices?.forEach((invoice: any, invoiceIndex: number) => {
    invoice.products?.forEach((product: any, productIndex: number) => {
      if (!product?.product?.clientIdentifier && !product?.clientIdentifier) {
        additionalErrors.push({
          title: 'SKU missing',
          type: ValidationErrorType.MISSING_FIELD,
          path: ['invoices', invoiceIndex, 'products', productIndex, 'product'],
          messages: [],
        });
      }
    });
  });
  if (additionalErrors.length) {
    additionalErrors.push({
      title: 'Please fix errors for AMP2.0 original booking',
      messages: [],
    });
  }
  return validateForm({
    form,
    additionalErrors: additionalErrors.length ? additionalErrors : undefined,
    skipValidateFields: true,
    currentUserId,
    setErrorState: (errors: any) =>
      dispatch(
        setValidationErrors({
          recordId: record.id,
          validationResult: errors,
        }),
      ),
  });
};
